import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { handleErrorInCatch, showToastByMenuDirection } from '../../helper/functions'
import { globalOnDemandVars } from '../../helper/context'
import { Button, ButtonGroup, NonIdealState } from '@blueprintjs/core'
import { resetConfig } from '../../backend/configs/updateData'
import { initConfig } from '../../backend/configs/initData'
import { withTranslation } from 'react-i18next'

const refresh = () => {
  globalOnDemandVars.refresh()()
}
const hardRefresh = () => {
  location.reload()
}
class ErrorBoundary extends React.Component {
  // this.state = { hasError: false };
  constructor (props) {
    super(props)
    this.state = {
      hasError: false
    }
    this.refreshLocally = () => {
      this.setState({
        hasError: false
      })
    }
  }
  static getDerivedStateFromError (error) {
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    // Display fallback UI
    // this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);

    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'componentDidCatch',
        value: {
          error,
          info,
          props: this.props
        },
        important: true
      })
    }
    this.setState({
      hasError: true
    })

    // showToastByMenuDirection({
    //   message: 'Some error occurred',
    //   intent: 'warning',
    //   action: {
    //     icon: 'refresh',
    //     text: 'refresh',
    //     onClick: this.props.global ? this.hardRefresh : this.refresh
    //   }
    // })
  }

  render () {
    let result
    if (this.state.hasError) {
      let actionF
      switch (this.props.where) {
        case 'global':
          actionF = hardRefresh
          break
        case 'route':
          actionF = refresh
          break
        default:
          actionF = this.refreshLocally
          break
      }
      // You can render any custom fallback UI
      result = <NonIdealState
        icon={'error'} title={this.props.t('Some error occurred')} action={(
          <ButtonGroup>
            <Button icon={'refresh'} text={this.props.t('Reload')} onClick={() => {
              globalOnDemandVars.refresh()()
            }} />
            <Button icon={'refresh'} text={this.props.t('Hard Reload')} onClick={() => {
              location.reload()
            }} />
          </ButtonGroup>
        )}
      />
    } else {
      result = this.props.children
    }

    return result
  }
}

export default withTranslation()(ErrorBoundary)

// {/* <ButtonGroup> */}
// {/*  <Button icon={'refresh'} text={'Retry'} onClick={actionF} />*/}
// {/*  <Button text={'Refresh'} onClick={() => {*/}
// {/*    globalOnDemandVars.refresh()()*/}
// {/*  }} />*/}
// {/*  <Button text={'Hard Refresh'} onClick={() => {*/}
// {/*    location.reload()*/}
// {/*  }} />*/}
// {/*  <Button text={'Reset Config'} onClick={() => {*/}
// {/*    resetConfig().then(() => {*/}
// {/*      return initConfig()*/}
// {/*    }).then(r => {*/}
// {/*      globalOnDemandVars.refresh()()*/}
// {/*    })*/}
// {/*  }} />*/}
// {/* </ButtonGroup> */}
